import { all } from 'redux-saga/effects';

import * as compareSagas from './compare/sagas';
import * as endpointsSagas from './endpoints/sagas';
import * as metricsSagas from './metrics/sagas';
import * as routerSagas from './router/sagas';
import * as favoritesSagas from './favorites/sagas';
import { sagas as authSagas } from './auth/sagas';

const allSagas = Object.values({
  ...compareSagas,
  ...endpointsSagas,
  ...metricsSagas,
  ...routerSagas,
  ...authSagas,
  ...favoritesSagas,
});

export default function* rootSagas() {
  yield all(allSagas.map((saga) => saga()));
}
